import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-line bg-navy-900 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxixd0oo855">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop5xzg7sxjt">The {totalBonuses} <span className="text-gold" data-id="element-21" data-mp="15pw10vezuev9">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 divide-y divide-line overflow-hidden rounded-xl border border-line bg-navy-950 shadow-lg shadow-black/30" data-id="element-22" data-mp="1jgr75zy3yhv5">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-center gap-4 p-5 sm:p-6" data-id="element-23" data-mp="qzoiygswexv3" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-fiber/10 text-fiber" data-id="element-24" data-mp="2jhmkki0ctf4z">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2ofo5l8hcboj3" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-26" data-mp="1quabnan495u5">
                  <p className="text-sm font-semibold text-gold" data-id="element-27" data-mp="1qvlffagkadl9">Bonus {bonus.number}</p>
                  <h3 className="mt-0.5 text-base font-semibold leading-snug text-white sm:text-lg" data-id="element-28" data-mp="1vuei07ub8k6n">{bonus.title}</h3>
                </div>
                <p className="shrink-0 text-right text-sm" data-id="element-29" data-mp="25r11otawh573">
                  <span className="block text-silver/70 line-through decoration-gold" data-id="element-30" data-mp="25oeu4to0epov">{bonusValue}</span>
                  <span className="block font-bold text-gold" data-id="element-31" data-mp="3c8wi2qixv873">FREE</span>
                </p>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-xl border border-gold/60 bg-navy-950 px-6 py-6 text-center shadow-lg shadow-black/30 sm:flex-row sm:text-left" data-id="element-32" data-mp="1h2m3hafr1ny2">
          <div data-id="element-33" data-mp="1q4d6g7iwngo8">
            <p className="text-sm font-medium text-silver" data-id="element-34" data-mp="1q2scaj0i5zqw">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-semibold tracking-tight text-silver/70 line-through decoration-gold decoration-2" data-id="element-35" data-mp="1m3jgl8lwjrsp">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-36" data-mp="tevsz6dokqbz">
            <p className="text-sm font-medium text-silver" data-id="element-37" data-mp="tbq4ntcvlshb">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-gold" data-id="element-38" data-mp="176sf8tso460g">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-39" data-mp="12d7tc04cn2hm" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}